export default __webpack_public_path__ + "beb7fe13e61b9e683c3778a5e2dc4e01.ttf";